export const Translations = {
	en: {
		homeHeader:
			"Textbankr is a 100% free tool to make it easier to call and message contacts.",
		homeBody: (
			<>
				<b>How does it work?</b>
				<ol>
					<li>
						Write a draft message - or two different versions, for example
						depending on whether or not the contact answers the phone.
					</li>
					<li>
						Paste your contacts in - you can copy the names and numbers from a
						spreadsheet right into the tool.
					</li>
					<li>
						Send your messages! Once you’ve inputted your contacts and
						template messages, pre-filled links will allow you to send messages
						quickly and easily, without needing to type in numbers manually or
						save any contacts.
					</li>
					<li>
						<em>Optionally</em> - if it’s easier to send the messages from your
						phone, you can get set up on your desktop and then easily send all
						the data to your mobile to call your contacts and send the messages.
						You can also 'host a session' and easily divvy up contacts between
						attendees.
					</li>
				</ol>
				This tool is designed for low- to no-budget organisations - though it
				works for everyone. It is designed to not store any sensitive data,
				anywhere at all. Everything you input is only kept locally right on your
				browser, and vanishes the moment you close the window.
			</>
		),
		homeBtn: "Get started",
		homeDisclaimer: (
			<>
				Please note that this is still very much a work-in-progress.
				<br />
				Any bugs or suggestions, email: <b>gordonmaloney @ gmail . com</b>
			</>
		),
		textbankrSendMsg: "Send your message",
		textbankrSendBlurb: (
			<>
				It’s easiest to send the messages from a mobile. If you chose to do
				that, there’s also a one-click to call button for each contact, so you
				don’t need to type the numbers in to ring them. However, if you’d
				prefer, you can send your message from right here in your browser.
				<br />
				<br />
				If you are hosting a session, you can use the button below to divvy up
				the contacts between attendees.
			</>
		),
		textbankrSendBrowser: "Send from browser",
		textbankrFallback:
			"Add in your contacts and a template message above, and you can use the buttons below to call, WhatsApp, and text them:",
		scanBtn: "Scan Data from Desktop",
		scanSuccess: "All QR codes scanned and data reconstructed!",
		scanXofY: "Scanned",
		scanInvalid: "Invalid QR Code data. Please try again.",
		scanError: "QR Code scan error:",
		inputHeader: "Draft your message",
	},
	fr: {
		homeHeader:
			"Textbankr est un outil 100 % gratuit pour faciliter les appels et les messages aux contacts.",
		homeBody: (
			<>
				<b>Comment ça marche ?</b>
				<ol>
					<li>
						Rédigez un message brouillon - ou deux versions différentes, par
						exemple selon que le contact répond ou non au téléphone.
					</li>
					<li>
						Copiez-collez vos contacts - vous pouvez copier les noms et les
						numéros depuis un tableur directement dans l'outil.
					</li>
					<li>
						Envoyez vos messages ! Une fois vos contacts et vos messages modèles
						saisis, des liens pré-remplis vous permettront d'envoyer rapidement
						et facilement les messages, sans avoir à taper les numéros
						manuellement ni à enregistrer de contacts.
					</li>
					<li>
						<em>Optionnellement</em> - si vous préférez envoyer les messages de
						votre téléphone, vous pouvez tout configurer sur votre ordinateur,
						puis transférer facilement toutes les données sur votre mobile pour
						appeler vos contacts et envoyer les messages. Vous pouvez également
						"héberger une session" et répartir facilement les contacts entre les
						participants.
					</li>
				</ol>
				Cet outil est conçu pour les organisations à faible ou sans budget -
				mais il fonctionne pour tout le monde. Il est conçu pour ne stocker
				aucune donnée sensible, nulle part. Tout ce que vous saisissez est
				uniquement conservé localement dans votre navigateur et disparaît dès
				que vous fermez la fenêtre.
			</>
		),
		homeBtn: "Commencer",
		homeDisclaimer: (
			<>
				Veuillez noter que cet outil est encore en cours de développement.
				<br />
				Pour signaler un bug ou faire une suggestion, envoyez un email à :{" "}
				<b>gordonmaloney @ gmail . com</b>
			</>
		),
	},
};
